module.exports = __webpack_public_path__ + "img/files.202a581c.png";